<template>
    <div class="email-listing-actions">
        <CompassMenu
            v-if="showActionsMenu"
            trigger="click"
            customClass="email-listing-actions__menu"
        >
            <CompassIconButton icon="action" />
            <template #dropdown>
                <CompassMenuItem
                    v-if="isReceivedTableOrSentTable"
                    :label="$t.__('common.actions.display')"
                    :disabled="!email.canRead"
                    @click="handleOpenEmail"
                />
                <CompassMenuItem
                    v-if="isReceivedTableOrSentTable"
                    :label="$t.__('common.actions.manage_related')"
                    :disabled="!email.canUpdateRelated"
                    @click="handleOpenRelated"
                />
                <CompassMenuItem
                    v-if="isReceivedTable"
                    :label="changeReadingStatusButtonLabel"
                    :disabled="!email.canUpdate"
                    @click="handleUpdateReadingStatus"
                />
                <CompassMenuItem
                    v-if="isOutboxTable"
                    :label="$t.__('common.actions.resend')"
                    :disabled="email.status !== 'failed_to_send'"
                    @click="handleResend"
                />
                <CompassMenuItem
                    v-if="showDeleteActions"
                    :label="$t.__('common.actions.delete')"
                    @click="handleDelete"
                />
            </template>
        </CompassMenu>
    </div>
</template>
<script>
import { resendFailedEmailById } from 'api/emailEngine/emailEngineService';
import EmailsListingMixins from 'mixins/emails/EmailsListingMixins';
import { createNamespacedHelpers } from 'vuex';
const popupPanelMapActions = createNamespacedHelpers('popupPanel').mapActions;

export default {
    mixins: [EmailsListingMixins],
    props: {
        email: {
            type: Object,
            required: true,
        },
    },
    computed: {
        showActionsMenu() {
            return this.email.status !== 'waiting_to_be_sent';
        },
        showDeleteActions() {
            return (
                this.email.status === 'failed_to_send' ||
                this.email.status === 'scheduled_to_be_sent'
            );
        },
        changeReadingStatusButtonLabel() {
            return this.email.unread
                ? this.$t.__('email.listings.EmailListingActions.mark_as_read')
                : this.$t.__('email.listings.EmailListingActions.mark_as_unread');
        },
    },
    methods: {
        ...popupPanelMapActions(['open']),
        handleResend() {
            resendFailedEmailById(this.email.id)
                .then(() => {
                    this.$pushToast({
                        close: true,
                        text: this.$t.__('email.EmailListingActions.email_resent'),
                        type: 'success',
                    });
                    EventBus.emit('refreshOutBoxEmailListing');
                })
                .catch((error) => {
                    this.$pushToast({
                        close: true,
                        text: error,
                        type: 'error',
                    });
                });
        },
        handleDelete() {
            this.open({
                key: 'emailDeleteConfirmDialog',
                props: {
                    email: this.email,
                },
            });
        },
        handleUpdateReadingStatus() {
            this.$emit('update:readingStatus', {
                emailProviderThreadId: this.email.provider_thread_id,
            });
        },
        handleOpenEmail() {
            this.openEmailPanel(this.email);
            if (this.email.unread) {
                this.$emit('update:readingStatus', {
                    emailProviderThreadId: this.email.provider_thread_id,
                    unreadStatus: false,
                    showToaster: false,
                });
            }
        },
        handleOpenRelated() {
            this.$emit('open:related', this.email);
        },
    },
};
</script>
<style lang="scss">
.compass-menu__dropdown__container.email-listing-actions__menu {
    z-index: 3;
}
</style>
<style lang="scss" scoped>
.email-listing-actions {
    display: flex;
    gap: var(--spacing-1);
}
</style>
